import { EMAIL_ACCOUNTS } from '@mm/api-routes';
import { EmailAccount } from '../interfaces/emailAccount';
import AuthenticatedController from './AuthenticatedController';

export default class EmailAccountController extends AuthenticatedController {
  static async getAccounts(facebookPageId: number) {
    return super.get(EMAIL_ACCOUNTS(), {
      facebook_page_id: facebookPageId,
    });
  }

  static async updateAccount(
    emailAccount: Partial<Omit<EmailAccount, 'id'>> & Pick<EmailAccount, 'id'>,
  ) {
    return super.put(EMAIL_ACCOUNTS(emailAccount.id), emailAccount);
  }
  static async createAccount(emailAccount: Partial<EmailAccount>) {
    return super.post(EMAIL_ACCOUNTS(), emailAccount);
  }

  static async deleteAccount(emailAccountId: number) {
    return super.delete(EMAIL_ACCOUNTS(emailAccountId));
  }
}
